// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0e2c88b8","104":"b62ebf78","453":"ec884319"}[chunkId] + ".chunk.js";
};